import { useMutation } from '@tanstack/react-query'
import { gemFiles } from '../../../v3'
import { OpalApiResponseDocument } from '../../schema'

export type CreateGemFileMutationParams = {
  fileName: string
  fileSize: number
  contentType: string
  workspaceUuid: string
  file: File
}

type GemFileResponseDocument = OpalApiResponseDocument<'CreateGemFileV3', 201>

type QueryParams = {
  mutationKey?: Array<string>
  onMutate?: (params: CreateGemFileMutationParams) => void
  onSuccess?: (
    data: GemFileResponseDocument,
    params: CreateGemFileMutationParams
  ) => void
  onError?: (error: unknown, params: CreateGemFileMutationParams) => void
}

export const useCreateGemFileMutation = ({
  mutationKey,
  onMutate,
  onSuccess,
  onError,
}: QueryParams) => {
  return useMutation({
    mutationKey,
    mutationFn: ({
      file,
      fileSize,
      fileName,
      contentType,
      workspaceUuid,
    }: CreateGemFileMutationParams) =>
      gemFiles.create(
        {
          header: {
            'X-File-Name': fileName,
            'X-File-Size': fileSize.toString(),
            'X-Mime-Type': contentType,
            'X-Workspace-Id': workspaceUuid,
          },
        },
        file
      ),
    onMutate,
    onSuccess,
    onError,
  })
}
